<template>
  <ResumeEditor
    v-if="ready"
    ref="editor"
    class="resume-editor"
    isAgency
    :is-edit-mode="isEditMode"
    :is-company-job-editable="isCompanyJobEditable"
    :hidden-id-number="hiddenIdNumber"
    :value="resumeInfo"
    :stepSetting="resumeEditorSetting"
    :isNewPage="true"
    @cancel="handleCancel"
    @save="handleSave"
    @save-back="handleSaveAndBack"
  />
</template>

<script>
import { mapActions } from 'vuex'
import ResumeEditor from '@/components/candidate/editor/layout.vue'
import { STEP_TYPE } from '@/constant/candidate'
import { mixedRouterPush } from '@/router/routes'
// import _ from 'lodash'

export default {
  components: {
    ResumeEditor
  },
  data () {
    return {
      ready: false,
      readyPromise: [],
      hiddenIdNumber: true,
      jobInfo: {},
      resumeInfo: {},
      resumeEditorSetting: {
        hiddenStep: [STEP_TYPE.DESCRIPTION, STEP_TYPE.PRESCREEN_QUESTIONNAIRE, STEP_TYPE.JOB_QUESTIONNAIRE, STEP_TYPE.INVITE_QUESTIONNAIRE, STEP_TYPE.HR_QUESTIONNAIRE, STEP_TYPE.ONBOARDING_QUESTIONNAIRE],
        displayStep: [STEP_TYPE.UPLOAD_RESUME],
        [STEP_TYPE.UPLOAD_RESUME]: {
          needUploadResume: false,
          hasAIResumeParsePermission: false
        },
        [STEP_TYPE.BASE_INFO]: {
          hiddenField: ['companyJob'],
          displayField: [],
          requiredField: [],
          loadJobData: false
        }
      }
    }
  },
  computed: {
    isEditMode () {
      return this.$route.meta.isEditMode
    },
    jobId () {
      return this.$route.params.jobId
    },
    applicationId () {
      return this.$route.params.applicationId
    },
    isCompanyJobEditable () {
      return !this.isEditMode && this.jobId === '-1'
    }
  },
  created () {
    this.readyPromise.push(this.getJobInfo())
    if (this.isEditMode) {
      this.readyPromise.push(this.getResumeInfo())
    } else {
      const jobId = this.jobId
      if (jobId !== '-1') {
        this.readyPromise.push(this.initJobApplyRequiredInfo())
        this.resumeInfo = { baseInfo: { companyJob: parseInt(jobId) } }
      }
    }

    this.$eventBus.$emit('showLoading', true)
    Promise.all(this.readyPromise).then(() => {
      this.ready = true
      this.$nextTick(() => {
        if (this.isEditMode) {
          const targetStep = {
            stepType: STEP_TYPE.BASE_INFO
          }
          this.$refs.editor.showStepPage(targetStep)
        }
      })
    }).finally(() => {
      this.$eventBus.$emit('showLoading', false)
    })
  },
  methods: {
    ...mapActions('agency', ['getApplicationResumeInfo', 'createCandidateByJob', 'headhunterUploadCandidatePhoto', 'updateCandidateInfo', 'getJobInfoByJobId']),
    ...mapActions('application', ['getJobApplyRequiredInfo']),
    async getJobInfo () {
      const resp = await this.getJobInfoByJobId(this.jobId)
      if (resp) {
        this.jobInfo = resp
        this.initResumeSetting()
      }
    },
    async getResumeInfo () {
      const params = {
        jobId: this.jobId,
        applicationId: this.applicationId
      }
      const resp = await this.getApplicationResumeInfo(params)
      if (resp) {
        this.resumeInfo = resp
      }
    },
    async initJobApplyRequiredInfo () {
      // 编辑简历的时候不需要查找
      if (this.isEditMode) {
        return
      }
      if (this.jobId) {
        const resp = await this.getJobApplyRequiredInfo(this.jobId)
        if (resp) {
          if ((resp.required_field || []).includes('resume')) {
            this.resumeEditorSetting[STEP_TYPE.UPLOAD_RESUME].needUploadResume = true
          }
        }
      }
    },
    initResumeSetting () {
      if (!this.jobInfo || !this.jobInfo.company) {
        return
      }
      if (this.jobInfo.email_and_mobile_required) {
        this.resumeEditorSetting[STEP_TYPE.BASE_INFO].requiredField.push('emailAddress', 'mobile')
      }

      if (this.jobInfo.photo_required) {
        this.resumeEditorSetting[STEP_TYPE.BASE_INFO].requiredField.push('photo')
      }
      if (this.jobInfo.company?.has_ai_resume_parse_premium) {
        this.resumeEditorSetting[STEP_TYPE.UPLOAD_RESUME].hasAIResumeParsePermission = true
      }
    },
    async handleCancel () {
      let backPath = `/v-agency/job/${this.jobId}/application`
      if (!this.isEditMode) {
        backPath = '/v-agency/job-list'
      }
      mixedRouterPush(this.$route.query.back || backPath)
    },
    async handleSave (resumeInfo, autoBack) {
      this.$eventBus.$emit('showLoading', true)
      try {
        let resp = null
        const photoFile = resumeInfo.baseInfo?.photoFile
        resumeInfo = {
          ...resumeInfo,
          jobId: this.jobId,
          baseInfo: {
            ...resumeInfo.baseInfo,
            companyJob: this.jobId,
            photo: photoFile ? null : resumeInfo.baseInfo.photo,
            photoFile: null
          }
        }
        if (this.isEditMode) {
          resumeInfo.applicationId = this.applicationId
          resp = await this.updateCandidateInfo(resumeInfo)
        } else {
          resp = await this.createCandidateByJob(resumeInfo)
        }
        if (resp) {
          if (photoFile) {
            const candidateId = resp.candidate_id
            const jobId = resp.job_id
            await this.headhunterUploadCandidatePhoto({ candidateId, jobId, photo: photoFile })
          }
          this.$message.success(this.$t('admin.application.candidate.message.headhunterUploadSuccess'))
          if (autoBack) {
            mixedRouterPush(this.$route.query.back || `/v-agency/job/${this.jobId}/application`)
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleSaveAndBack (jobTemplateInfo) {
      return this.handleSave(jobTemplateInfo, true)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
